import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { Title } from '../../typography/Title/Title';

export const AutoSlider = ({ images, title }) => {
  const [index, setIndex] = useState(0);
  const [isTransition, setIsTransition] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (index === images.length) {
      setTimeout(() => {
        setIsTransition(false);
        setIndex(0);
      }, 500);
    } else {
      setIsTransition(true);
    }
  }, [index, images.length]);

  return (
    <div className={styles.container}>
      <div
        className={styles.track}
        style={{
          transform: `translateX(-${index * 100}%)`,
          transition: isTransition ? 'transform 0.5s ease-in-out' : 'none',
        }}
      >
        {images.map((src, i) => (
          <img key={i} src={src} className={styles.slide} />
        ))}

        <img src={images[0]} className={styles.slide} />
      </div>
      <div className={styles.overlay}></div>
      <Title tag='h2' className={styles.title}>
        {title}
      </Title>
    </div>
  );
};
